import { render, staticRenderFns } from "./SupplierInfo.vue?vue&type=template&id=7de48736&scoped=true"
import script from "./SupplierInfo.vue?vue&type=script&lang=ts"
export * from "./SupplierInfo.vue?vue&type=script&lang=ts"
import style0 from "./SupplierInfo.vue?vue&type=style&index=0&id=7de48736&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7de48736",
  null
  
)

export default component.exports